import { useState, useCallback } from 'react';
import type { CoffeeBean, FilterOptions, SortOption } from '@/types';

export default () => {
  const [beans, setBeans] = useState<CoffeeBean[]>([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState<FilterOptions>({});
  const [sortBy, setSortBy] = useState<SortOption>('default');
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  
  const fetchBeans = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      // TODO: 替换为实际API调用
      // const response = await getBeansList({ page, filters, sortBy });
      // setBeans(response.data);
      // setTotal(response.total);
      setCurrentPage(page);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [filters, sortBy]);
  
  const updateFilters = useCallback((newFilters: Partial<FilterOptions>) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  }, []);
  
  const clearFilters = useCallback(() => {
    setFilters({});
  }, []);
  
  return {
    beans,
    loading,
    filters,
    sortBy,
    total,
    currentPage,
    fetchBeans,
    updateFilters,
    clearFilters,
    setSortBy,
  };
};
